import { ZoomIn, ZoomOut } from "lucide-react";

export interface ZoomControlsProps {
  zoomCapability: { min: number; max: number; step: number };
  currentZoom: number;
  onZoomChange: (level: number) => void;
}

export function ZoomControls({
  zoomCapability,
  currentZoom,
  onZoomChange,
}: ZoomControlsProps) {
  return (
    <div className="absolute bottom-28 right-4 left-auto top-20 z-10 flex flex-col items-center justify-center gap-2">
      <button
        onClick={() =>
          onZoomChange(
            Math.min(
              currentZoom + zoomCapability.step,
              zoomCapability.max,
            ),
          )
        }
        className="rounded-full bg-black/50 p-2 text-white backdrop-blur-sm active:bg-black/70"
        aria-label="Zoom in"
      >
        <ZoomIn className="h-5 w-5" />
      </button>
      <input
        type="range"
        min={zoomCapability.min}
        max={zoomCapability.max}
        step={zoomCapability.step}
        value={currentZoom}
        onChange={(e) => onZoomChange(Number(e.target.value))}
        className="zoom-slider h-32"
        style={{
          writingMode: "vertical-lr",
          direction: "rtl",
        }}
        aria-label="Zoom level"
      />
      <button
        onClick={() =>
          onZoomChange(
            Math.max(
              currentZoom - zoomCapability.step,
              zoomCapability.min,
            ),
          )
        }
        className="rounded-full bg-black/50 p-2 text-white backdrop-blur-sm active:bg-black/70"
        aria-label="Zoom out"
      >
        <ZoomOut className="h-5 w-5" />
      </button>
      <span className="mt-1 rounded-full bg-black/50 px-2 py-0.5 text-xs text-white backdrop-blur-sm">
        {(Number.isFinite(currentZoom) ? currentZoom : 1).toFixed(1)}x
      </span>
    </div>
  );
}
